import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from '@lt/localization';

import {
  HotelExperienceCard,
  HotelExperienceExpanded,
  HotelStars,
  Slider,
} from '@lt/components';

import Container from '../../components/Container';

import styles from './experienceContainer.module.css';

const { HotelExperiencePropTypes } = HotelExperienceCard;

const createMarkup = (encodedHtml) => ({
  __html: _.unescape(encodedHtml),
});

const HotelExperienceList = ({
  experiences,
  hotelName,
  hotelStars,
  isMobile,
  scrollToSectionTop,
  ...props
}) => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(null);
  const [isCollapsing, setCollapsing] = useState(false);
  const expandedExperience = experiences[index];

  const changeSlide = (newIndex) => {
    setCollapsing(true);
    setTimeout(() => {
      setIndex(newIndex);
      setCollapsing(false);
      scrollToSectionTop();
    }, 400);
  };

  return (
    !_.isEmpty(experiences) && (
      <Container
        className={classnames(styles.hotelExperienceList)}
        isMobile={isMobile}
        white={isMobile}
        {...props}
      >
        <Container
          className={styles.container}
          isMobile={isMobile}
          fullWidth={isMobile}
        >
          <h2
            className={classnames(styles.title, {
              [styles.titleMobile]: isMobile,
            })}
          >
            {t('hotel.experienceMobile')}
            <span
              className={classnames(styles.hotelName, {
                [styles.hotelNameMobile]: isMobile,
              })}
            >
              <span
                className={styles.label}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={createMarkup(hotelName)}
              />
              {!isMobile && (
                <HotelStars
                  className={styles.hotelStars}
                  value={hotelStars}
                  size={15}
                />
              )}
            </span>
          </h2>
        </Container>
        {expandedExperience && (
          <Container
            className={classnames(styles.container, styles.expanderContainer)}
            isMobile={isMobile}
            fullWidth
            style={{
              animation: !isMobile && isCollapsing ? 'unmount' : 'mount',
            }}
          >
            <Container
              className={styles.container}
              fullWidth={isMobile}
              isMobile={isMobile}
            >
              <HotelExperienceExpanded
                isMobile={isMobile}
                onCollapse={() => changeSlide(null)}
                {...expandedExperience}
              />
            </Container>
          </Container>
        )}
        <Container
          className={styles.container}
          isMobile={isMobile}
          fullWidth={isMobile}
        >
          <Slider
            controls={!isMobile}
            dots={!isMobile}
            gap={isMobile ? 8 : 20}
            offset={10}
          >
            {experiences.map((item, i) => (
              <HotelExperienceCard
                className={classnames(styles.hotelExperienceCard, {
                  [styles.hotelExperienceCardMobile]: isMobile,
                })}
                key={item.title}
                isMobile={isMobile}
                onExpand={() => changeSlide(i)}
                data-hidden={i === index}
                {...item}
              />
            ))}
          </Slider>
        </Container>
      </Container>
    )
  );
};

HotelExperienceList.propTypes = {
  className: PropTypes.string,
  experiences: PropTypes.arrayOf(HotelExperiencePropTypes),
  hotelName: PropTypes.string,
  hotelStars: PropTypes.number,
  isMobile: PropTypes.bool,
  scrollToSectionTop: PropTypes.func,
};

HotelExperienceList.defaultProps = {
  className: '',
  experiences: [],
  hotelName: null,
  hotelStars: null,
  isMobile: false,
  scrollToSectionTop: Function.prototype,
};

export default HotelExperienceList;
